// extracted by mini-css-extract-plugin
module.exports = {"line-clamp-1":"line-clamps_line-clamp-1__rWnQV","line-clamp-4":"line-clamps_line-clamp-4__rN6sH","line-clamp-5":"line-clamps_line-clamp-5__0EfXF"};